module.exports = __webpack_public_path__ + "static/media/ONE.8f3ad7a0.png";